document.querySelectorAll('.scroll-on-product-section').forEach(function(btn){
btn.addEventListener('click', function(e){
e.preventDefault();
const target = document.querySelector('.featured-product');
if(target){
    const topOffset = -140;
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition + topOffset;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}
});
});
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.scroll-on-faq-section').forEach(function(btn){
btn.addEventListener('click', function(e){
    e.preventDefault();
    if(window.location.pathname !== '/'){
    sessionStorage.setItem('scrollToFaq', 'true');
    window.location.href = '/';
    } else {
    const target = document.querySelector('#collapsible-content-section-el');
    if(target){
        target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
        });
    }
    }
});
});
if(
window.location.pathname === '/' &&
sessionStorage.getItem('scrollToFaq') === 'true'
){
sessionStorage.removeItem('scrollToFaq');
setTimeout(function(){
    const target = document.querySelector('#collapsible-content-section-el');
    if(target){
    target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
    }
}, 400);
}
});